import axios from 'axios';
import { METHOD } from './constants';
import ApiClient from '../api/ApiClient';

class ApiClientWeb extends ApiClient {

    request({ serverUrl, url, method, body, authToken = null }) {
        const config = {
            method,
            baseURL: serverUrl,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Accept-Encoding': 'gzip'
            },
            timeout: 30000
        };

        if (authToken) {
            config.headers.Authorization = authToken;
        }

        const isPayloadMethod = !~[METHOD.GET, METHOD.HEAD, METHOD.DELETE].indexOf(method);

        // Append 'payload' for data methods
        if (isPayloadMethod) {
            config.data = body;
        }

        return axios(config).then(({ data }) => {
            return Promise.resolve(data);
        }).catch(error => {
            return Promise.reject(error);
        });
    }
}

export default ApiClientWeb;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/api/ApiClientWeb.js